import { API } from "../../utils/http";

export function getApplicationApi() {
	return new Promise((resolve, reject) => {
		API.get("application")
			.then((r) => {
				console.log(r);
				const user = r.data.payload;
				// console.log(user);
				resolve(user);
			})
			.catch((e) => {
				reject(e);
			});
	});
}
